import React from 'react';
import {callback} from '../../../helpers.js';
import PopupRowSelector from '../../farm/field/PopupRowSelector.js';
import ManagedWeightInput from '../../forms/ManagedWeightInput.js';

const BlueberryHandpickTask = (props) => {


	const onRowsChange = (selected) => {
		callback(props.onChange, [{
			'rows': selected,
			'amount': props.data.amount
		}]);
	}

	const onWeightChange = (e) => {
		callback(props.onChange, [{
			'rows': props.data.rows,
			'amount': e.target.value
		}]);
	}


	// Should this be lbs or kgs... like should we allow units here..
	// If so I can make a component for that... similar to the DistanceInput, but WeightInput
//		<PopupRowSelector date={props.date} field={props.field} rows={props.data.rows} onSubmit={onRowsChange} />

	return <span>
		<ManagedWeightInput name="weight" value={props.data.amount} placeholder="Weight" onChange={onWeightChange} />
	</span>;
}

BlueberryHandpickTask.getdataformat = () => {
	return {
		'rows': [],
		'amount': 0 // kg
		// It should send back amount too, but we don't *really* care about that for interface display..
		// Or that can come in especially from the attendance record
	}
};

export default BlueberryHandpickTask;